import React from 'react';
import { useQuery } from '@tanstack/react-query';
import DashboardSection from './components/DashboardSection';
import DashboardPage from './components/DashboardPage';
import CompletionSummary from './components/CompletionSummary';
import AgencyQueueTable from './components/AgencyQueueTable';
import useDashboardScope from './useDashboardScope';

import { statValue, readAgencyQueue } from './stats';

const MedicalDashboard = () => {
  const { api, campaignYear, enabled, queryOptions, scope } = useDashboardScope();
  const query = useQuery({
    ...queryOptions,
    queryKey: ['trip/stats/health/', ...scope],
    queryFn: api.list('trip/stats/health/', { year: campaignYear }),
  });
  const stats = query.data?.data?.data;
  const counts = {
    total: statValue(stats, 'Pèlerins inscrits'),
    examined: statValue(stats, 'Pèlerins examinés'),
    awaiting: statValue(stats, "Pèlerins en attente d'examen"),
    fit: statValue(stats, 'Pèlerins aptes'),
    unfit: statValue(stats, 'Pèlerins inaptes'),
  };
  const data = Object.values(counts).every(Number.isFinite)
    ? { ...counts, agencies: readAgencyQueue(stats, 'examined') }
    : null;
  return (
    <DashboardPage
      ariaLabel="Tableau de bord médical"
      title="Tableau de bord médical"
      subtitle={`Campagne ${campaignYear || 'indisponible'}`}
      enabled={enabled}
      queries={[query]}
      hasCompleteData={!!data}
      errorMessage="Actualisation impossible"
    >
      <DashboardSection title="Examens médicaux" query={query} available={!!data}>
        {data && (
          <>
            <CompletionSummary
              total={data.total}
              completed={data.examined}
              awaiting={data.awaiting}
              label="Pèlerins examinés"
            />
            <div className="mt-[18px] flex flex-wrap items-center gap-7 border-t pt-3.5 text-[13px] text-slate-500">
              <span>Parmi les {data.examined.toLocaleString('fr-FR')} examinés</span>
              <span>
                <strong className="mr-2 text-2xl text-slate-900">{data.fit.toLocaleString('fr-FR')}</strong>Pèlerins
                aptes
              </span>
              <span>
                <strong className="mr-2 text-2xl text-slate-900">{data.unfit.toLocaleString('fr-FR')}</strong>
                Pèlerins inaptes
              </span>
            </div>
          </>
        )}
      </DashboardSection>
      <DashboardSection title="File médicale par société" query={query} available={!!data}>
        {data && <AgencyQueueTable rows={data.agencies} completedKey="examined" completedLabel="Examinés" />}
      </DashboardSection>
    </DashboardPage>
  );
};
export default MedicalDashboard;
